var _defs, _rect, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".error-a{fill:rgba(0,0,0,0);}.error-b{fill:#fff;opacity:0.3;}.error-c{fill:#ed1d24;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "error-a",
    width: 70,
    height: 70
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "error-b",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(5 5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "error-c",
    d: "M33,66A33.009,33.009,0,0,1,20.155,2.593a33.009,33.009,0,0,1,25.69,60.813A32.8,32.8,0,0,1,33,66Zm.033-59.4A26.4,26.4,0,1,0,59.432,33,26.43,26.43,0,0,0,33.032,6.6Zm3.3,42.9h-6.6V42.9h6.6v6.6Zm0-13.2h-6.6V16.5h6.6V36.3Z",
    transform: "translate(2 2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.943127703b878ca6b3a69fb660dcf17b.svg";
export { ForwardRef as ReactComponent };